//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'BaseSocial',

  computed: {
    items() {
      return [
        {
          url: 'https://instagram.com/humnutrition',
          label: 'Instagram',
          name: 'instagram',
          icon: 'instagram'
        },
        {
          url: 'https://facebook.com/humnutrition',
          label: 'Facebook',
          name: 'facebook',
          icon: 'facebook-f'
        },
        {
          url: 'https://twitter.com/humnutrition',
          label: 'Twitter',
          name: 'twitter',
          icon: 'twitter'
        },
        {
          url: 'https://www.youtube.com/channel/UCcwy4Ev5RlWtTFiN0wLa1ng',
          label: 'YouTube',
          name: 'youtube',
          icon: 'youtube'
        }
      ]
    }
  }
}
